import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const LOCATIONS = ["Shanzu Beach", "Serena Road Area", "Bamburi", "Nyali", "Mtwapa", "North Coast Mombasa"];

export default function ServiceArea() {
  return (
    <section id="area" className="relative overflow-hidden py-24 sm:py-32">
      <span className="font-display pointer-events-none absolute left-1/2 top-10 -translate-x-1/2 select-none whitespace-nowrap text-[19vw] font-extrabold uppercase leading-none text-outline">
        Shanzu
      </span>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mx-auto max-w-3xl pt-[16vw] text-center sm:pt-[10vw]"
        >
          <span className="inline-block rounded-full border border-[#C85A32]/40 bg-[#C85A32]/10 px-5 py-2 font-jbm text-[11px] font-semibold uppercase tracking-[0.25em] text-[#C85A32]">
            Shanzu, Mombasa
          </span>
          <h2 className="font-display mt-6 text-3xl font-bold tracking-tight text-[#1C3B2B] sm:text-4xl lg:text-5xl">
            Proudly serving Shanzu &amp; the coastal hubs around it
          </h2>
          <p className="mt-5 text-base leading-relaxed text-[#525B53] sm:text-lg">
            Based right in Shanzu, we reach your door fast — from Serena Road to Mtwapa creek.
            If you're on the North Coast, you're in our neighbourhood.
          </p>

          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {LOCATIONS.map((loc, i) => (
              <motion.span
                key={loc}
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                className="flex items-center gap-2 rounded-full border border-[#E4DDD3] bg-white px-5 py-2.5 text-sm font-semibold text-[#1C3B2B] shadow-sm transition-transform duration-300 hover:-translate-y-1"
              >
                <MapPin size={14} className="text-[#C85A32]" />
                {loc}
              </motion.span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
